import { Modal } from 'components/Modal';
import styles from './ModalLogout.module.scss';
import { Title } from 'components/Title';
import { Button } from 'ui/Button';
import { logOut } from 'redux/auth/slice';
import { authApi } from 'redux/Api/authApi/authApi';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export const ModalLogout = ({
  setShowLogoutModal,
}: {
  showLogoutModal: boolean;
  setShowLogoutModal: (e: boolean) => void;
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const logout = () => {
    navigate('/login', { replace: true });
    localStorage.removeItem('token');
    localStorage.removeItem('chatToken');
    localStorage.removeItem('role');
    dispatch(logOut());
    dispatch(authApi.util.resetApiState());
  };

  return (
    <Modal setOpen={setShowLogoutModal}>
      <div className={styles.root}>
        <Title className={styles.root_title} title='Ты уверен, что хочешь выйти?' />
        <p className={styles.root_text}>После выхода потребуется авторизоваться заново</p>
        <div className={styles.root_btn}>
          <Button
            onClick={() => {
              logout();
              setShowLogoutModal(false);
            }}
            className={styles.root_btn_exit}
            theme='outline'>
            Выйти
          </Button>
          <Button
            onClick={() => setShowLogoutModal(false)}
            className={styles.root_btn_cancel}
            theme='filed'>
            Отмена
          </Button>
        </div>
      </div>
    </Modal>
  );
};
